module.exports = __webpack_public_path__ + "icon_management_gray.a1479.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_management_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_management_gray.svg
// module chunks = main